var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isDevelopment)?_c('button',{style:({
    position: 'absolute',
    bottom: '0px',
    right: '0px',
    zIndex: 10,
    backgroundColor: 'yellow',
    display: _vm.hideWarning ? 'none' : 'block' }),attrs:{"id":"developerWarning"},on:{"click":function($event){return _vm.showAlert()}}},[_vm._v(" DEVELOPER VERSION ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }